/*
 * Stratus — Product row (sections/st-product-row.liquid)
 *
 * <st-product-row data-url="…/recommendations/products?section_id=…&product_id=…&limit=…&intent=…" [hidden]>
 * The page already renders the Search & Discovery picks (or the fallback collection) into
 * [data-st-product-row-track]: then this only makes sure the row shows. With an empty track, it fetches this same
 * section through the Section Rendering API with Shopify's recommendations as soon as the page is idle (no scroll
 * or IntersectionObserver: the row has to render in a capture and on a page nobody scrolls), swaps the tiles in
 * and shows the section. Nothing comes back: the section stays hidden. Runs again when the theme editor reloads
 * the section.
 */
(() => {
  if (customElements.get('st-product-row')) return;

  const whenIdle = (callback) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 2000 });
    } else {
      window.setTimeout(callback, 1);
    }
  };

  class StProductRow extends HTMLElement {
    connectedCallback() {
      if (this.dataset.stLoaded) return;
      const track = this.querySelector('[data-st-product-row-track]');
      if (track && track.querySelector('[data-product-block]')) {
        this.hidden = false;
        return;
      }
      this.dataset.stLoaded = 'true';
      whenIdle(() => this.load());
    }

    async load() {
      const url = this.dataset.url;
      if (!url || /product_id=(&|$)/.test(url)) return;
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-st-product-row-track]');
        const track = this.querySelector('[data-st-product-row-track]');
        if (!fresh || !track || !fresh.querySelector('[data-product-block]')) return;
        // Palo Alto's card parts (hover images, swatches) are custom elements: they upgrade on insert.
        track.replaceChildren(...Array.from(fresh.childNodes).map((node) => document.importNode(node, true)));
        this.hidden = false;
      } catch (error) {
        // Network or parse failure: the row stays hidden.
      }
    }
  }

  customElements.define('st-product-row', StProductRow);
})();
